import md5Lib from 'md5'
import sjcl, { type SjclCipherEncrypted } from 'sjcl'

/**
 * Computes the MD5 hash of a given plaintext string.
 *
 * @param plaintext - The plaintext string to hash.
 * @returns The MD5 hash of the input string in hexadecimal format.
 *
 * @example
 * console.log(md5("password")); // "5f4dcc3b5aa765d61d8327deb882cf99"
 */
export function md5(plaintext: string) {
  return md5Lib(plaintext)
}

/**
 * Encrypts a plaintext string using the Stanford JavaScript Crypto Library (SJCL).
 *
 * @param plaintext - The plaintext string to encrypt.
 * @param salt - An optional salt or password used as the encryption key. (Default: '')
 * @returns The encrypted ciphertext in JSON format.
 *
 * @example
 * const ciphertext = encrypt("secret", "mySalt");
 * console.log(ciphertext); // Encrypted JSON string
 */
export function encrypt(plaintext: string, salt = '') {
  return sjcl.encrypt(salt, plaintext)
}

/**
 * Decrypts an encrypted ciphertext using the Stanford JavaScript Crypto Library (SJCL).
 *
 * @param ciphertext - The ciphertext to decrypt, either as a JSON string
 *                                                     or as a parsed `SjclCipherEncrypted` object.
 * @param salt - The salt or password used to decrypt the ciphertext. (Default: '')
 * @returns The decrypted plaintext string.
 *
 * @example
 * const plaintext = decrypt(ciphertext, "mySalt");
 * console.log(plaintext); // "secret"
 */
export function decrypt(ciphertext: string | SjclCipherEncrypted, salt = '') {
  return sjcl.decrypt(salt, ciphertext)
}
